module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Flask-contrast-4ffa6a5d7d17a6d08924f0834ce4a9a3.svg";